import { PaymentComplete } from '../../components';
export const PaymentCompletePageView = () => {
  return <PaymentComplete data-sentry-element="PaymentComplete" data-sentry-component="PaymentCompletePageView" data-sentry-source-file="complete.tsx" />;
};